import axios from "axios";
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState,
} from "react";
import toast from "react-hot-toast";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import { baseServiceUrl, urls } from "../../environment";
import useUserStore from "../../stores/useUserStores";

type OfflineSyncModalProps = {};
const OfflineSyncModal: FC<OfflineSyncModalProps> = ({}): JSX.Element => {
  const {
    token,
    setLoading,
    loading,
    setOfflineExamLineInformation,
    offlineExamInformation,
    isResultIsUploaded,
    setuserdetail,
    setResultUploadedForOfflineCentre,
    isResultUploadedForOfflineCentre,
    setIsResultUploadedUploadedForOfflineCentre,
    setIsQuestionSynced,
    isQuestionSynced,
  } = useUserStore();
  const syncDownload = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${baseServiceUrl}${urls.syncDownload}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      setOfflineExamLineInformation(response.data);
      setIsQuestionSynced(true);
      toast.success(
        "Your Centre Question Set has been downloaded successfully."
      );
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || "Error encounter. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  if (!!isQuestionSynced) return <></>;
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-[rgba(0,0,0,0.5)] z-[85] fixed top-0 left-0">
      <div className="w-full h-full   ">
        <div className="flex justify-center w-full h-full items-center">
          <div className="lg:w-[40vw]  mx-auto  shadow-lg max-h-[200px] bg-white z-[99] rounded-md">
            <div className="bg-[#fee2e2]  p-2 rounded-tl-md rounded-tr-md flex gap-x-4 items-center justify-start ">
              <FiAlertCircle size={20} className="text-red-500 " />
              <p className="text-gray-500">
                Please sync with centralized server to download your question
                set{" "}
              </p>
            </div>
            <div className="bg-white flex py-10 items-center justify-center">
              <button
                onClick={() => syncDownload()}
                className=" px-4 text-gray-500 group rounded-md py-2 flex  items-center justify-center border border-[#2563EB] gap-x-3 group hover:bg-[#2563EB] duration-500 ease-linear "
              >
                <FaCloudDownloadAlt
                  className="text-[#2563EB] group-hover:text-white"
                  size={30}
                />
                <p className="text-lg font-semibold group-hover:text-white">
                  Download Question Set
                </p>
                {loading ? (
                  <div className="animate-spin h-5 w-5 mr-3 border border-gray-500 border-t-white rounded-full transition-all linear duration-500 " />
                ) : (
                  <></>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineSyncModal;
